<template>
  <div class="min-h-screen flex flex-col items-center justify-center bg-gradient-to-br from-gray-100 to-gray-300">
    <!-- Bloc principal avec effet de verre -->
    <div class="relative bg-white/40 backdrop-blur-xl shadow-2xl rounded-3xl p-4 sm:p-8 max-w-[90%] lg:max-w-3xl text-center">

      <!-- Icône avec animation -->
      <div class="flex justify-center animate-bounce-slow">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          class="h-32 w-32 sm:h-40 sm:w-40 text-[#FF9900]"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
          stroke-width="0.8"
        >
          <path
            stroke-linecap="round"
            stroke-linejoin="round"
            d="M9.172 16.172a4 4 0 015.656 0M9 10h.01M15 10h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
          />
        </svg>
      </div>

      <!-- Titre principal -->
      <h1 class="text-[6rem] sm:text-[8rem] font-extrabold text-gray-800 tracking-tighter mb-4">404</h1>

      <!-- Sous-titre -->
      <p class="text-2xl sm:text-3xl text-gray-700 font-light mb-2">{{ $t('oupscettepageestintrouvable') }}</p>

      <!-- Message d'explication -->
      <p class="text-base sm:text-lg text-gray-600 mb-10 leading-relaxed">
        {{ $t('ilsemblequecettepagenexistepas') }}
      </p>

      <!-- Bouton CTA -->
      <router-link
        to="/"
        class="inline-block bg-[#FF9900] text-white px-8 sm:px-10 py-3 sm:py-4 rounded-full text-base sm:text-lg font-semibold hover:bg-[#FFAD33] transition-transform duration-300 transform hover:scale-105 focus:outline-none focus:ring-4 focus:ring-[#FF9900] focus:ring-opacity-50"
      >
        Retour à l'accueil
      </router-link>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style>
/* Animation personnalisée pour un rebond lent */
@keyframes bounce-slow {
  0%, 100% {
    transform: translateY(0);
  }
  50% {
    transform: translateY(-10px);
  }
}

.animate-bounce-slow {
  animation: bounce-slow 3s infinite;
}
</style>
